export enum NonStandardStateLevel {
  'REQUEST' = 'REQUEST',
  'BATCH' = 'BATCH',
  'DOCUMENT' = 'DOCUMENT',
}
